export default __webpack_public_path__ + "static/media/StarRack2.2ab65853.png";